module.exports = __webpack_public_path__ + "img/avatar3.6369fba6.png";